var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpSFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1 17.7L16.3 29.3C15.8 30.1 16.4 31.1 17.3 31.1H30.9C31.8 31.1 32.4 30.1 31.9 29.3L25.1 17.7C24.7 16.9 23.5 16.9 23.1 17.7Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0645 17.1702L32.8422 28.7321C33.8039 30.2953 32.6188 32.2 30.9 32.2H17.3C15.5812 32.2 14.3961 30.2953 15.3578 28.7321L22.1355 17.1702C22.9521 15.6099 25.2479 15.6099 26.0645 17.1702ZM24.0785 18.2025C24.0692 18.2207 24.0593 18.2386 24.049 18.2563L17.249 29.8563C17.2437 29.8653 17.2383 29.8742 17.2328 29.883C17.2185 29.9059 17.2187 29.9162 17.2187 29.9185L17.2187 29.9187C17.2187 29.9246 17.2205 29.9375 17.2301 29.9542C17.2399 29.9714 17.2531 29.984 17.2646 29.991C17.2734 29.9963 17.2831 30 17.3 30H30.9C30.9169 30 30.9266 29.9963 30.9354 29.991C30.9469 29.984 30.9601 29.9714 30.9699 29.9542C30.9795 29.9375 30.9812 29.9246 30.9812 29.9187L30.9812 29.9185C30.9813 29.9162 30.9815 29.9059 30.9672 29.883C30.9617 29.8742 30.9563 29.8653 30.951 29.8563L24.151 18.2563C24.1407 18.2386 24.1308 18.2207 24.1215 18.2025C24.1158 18.2011 24.1084 18.2 24.1 18.2C24.0916 18.2 24.0842 18.2011 24.0785 18.2025Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2,
    height: 16.2,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpSFilled);
export default __webpack_public_path__ + "static/media/icon_up_s_filled.ae4df0f1.svg";
export { ForwardRef as ReactComponent };